import { useNavigate } from 'react-router-dom';
import CommonButton from '../../components/ui/CommonButton/CommonButton';
import InputField from '../../components/ui/InputField/InputField';
import classes from './Login.module.css';
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext'; // Assuming you have a login function here
import { env } from '../../constants/env';

const initial = {
  email: "",
  password: ""
};

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initial);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth(); // context that stores auth state

  const handleChange = (e) => {
    const newData = { [e.target.name]: e.target.value };
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  const handleLogin = async () => {
    const { email, password } = formData;
    if (!email || !password) {
      toast.error("Please enter both email and password");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${env.apiUrl}/api/admin/login`, {
        email,
        password
      });

      const { token, user } = response.data;

      // Save token and update auth context
      login(token, user); // Your AuthProvider should handle this
      toast.success("Login successful");
      navigate('/bookings'); // Redirect to dashboard or initial protected page
    } catch (error) {
      console.error(error);
      const errorMessage = error?.response?.data?.message || "Login failed";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`${classes.wrapper} d-flex justify-content-center align-items-center`}>
      <div className={classes.content}>
        <img src='/tiji-logo.svg' alt="Tiji Logo" className={classes.logo} />
        <h3>Log into your account</h3>
        <div className='d-flex flex-column gap-3 mt-3 mb-4'>
          <InputField type='email' placeholder="Email" name="email" value={formData.email} onChange={handleChange} />
          <InputField placeholder="Password" name="password" value={formData.password} type="password" showEye onChange={handleChange} />
        </div>
        <CommonButton title={loading ? "Logging in..." : "Login"} onClick={handleLogin} disabled={loading} />
      </div>
    </div>
  );
};

export default Login;